import React, { useState, useEffect } from "react";
import { Container, Row, Spinner, Button } from "react-bootstrap";
import pdf from "../../Assets/../Assets/Yash_Koparkar_Resume.pdf";
import { AiOutlineDownload } from "react-icons/ai";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/esm/Page/AnnotationLayer.css";

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

function ResumeNew() {
  const [width, setWidth] = useState(1200);
  const [showPdf, setShowPdf] = useState(false);

  useEffect(() => {
    setWidth(window.innerWidth);
  }, []);

  return (
    <div>
      <Container fluid className="resume-section">
        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>

        <Row className="resume">
          <div className="pdf-container">
            {!showPdf ? (
              <div className="pdf-placeholder">
                <div className="pdf-icon">
                  <svg width="80" height="80" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M14 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V8l-6-6zm-1 7V3.5L18.5 9H13zm-3 5h2v2H8v-2zm0 4h2v2H8v-2zm4-4h2v6h-2v-6zm0 4h2v2h-2v-2z"/>
                  </svg>
                </div>
                <p className="pdf-placeholder-text">Resume PDF</p>
                <p className="pdf-placeholder-subtext">Click below to view</p>
                <Button
                  variant="primary"
                  onClick={() => setShowPdf(true)}
                  className="view-pdf-btn"
                >
                  View Resume
                </Button>
              </div>
            ) : (
              <Document
                file={pdf}
                loading={
                  <div className="pdf-loading">
                    <Spinner animation="border" variant="primary" />
                    <p style={{ color: "white", marginTop: "15px" }}>Loading Resume...</p>
                  </div>
                }
                error={
                  <div className="pdf-error">
                    <p style={{ color: "white" }}>Failed to load PDF</p>
                    <Button href={pdf} target="_blank" variant="primary">
                      <AiOutlineDownload /> Download instead
                    </Button>
                  </div>
                }
              >
                <Page pageNumber={1} scale={width > 786 ? 1.7 : 0.6} />
              </Document>
            )}
          </div>
        </Row>

        <Row style={{ justifyContent: "center", position: "relative" }}>
          <Button
            variant="primary"
            href={pdf}
            target="_blank"
            style={{ maxWidth: "250px" }}
          >
            <AiOutlineDownload />
            &nbsp;Download CV
          </Button>
        </Row>
      </Container>
    </div>
  );
}

export default ResumeNew;